import React from "react";
const ContactForm = () => <section>hey i'm ContactForm</section>;
export default ContactForm;
